import api from '../api';
import axios from 'axios';
import gql from 'graphql-tag';
let template = {};
export default {
  data() {
    return {
      knowledgeDic: {},
      allDisease: [],
    };
  },
  methods: {
    formatConclusion(id) {
      let name;
      // 从自定义模板中找病种名称
      const f = data => {
        for (let i = 0; i < data.length; i++) {
          if (data[i].id === id) {
            name = data[i].name;
            break;
          } else if (data[i].children && data[i].children.length) {
            f(data[i].children);
          }
        }
      };
      if (template.myTemplate) {
        f(template.myTemplate);
      }
      // 如果自定义中没有找到则在原始模板中查找
      if (!name) {
        if (this.knowledgeDic[id]) {
          name = this.knowledgeDic[id].name;
        }
      }
      return name ? name : id;
    },
    // 根据id查 返回id或空
    formatConclusion2(id) {
      let searchId;
      // 从自定义模板中找病种名称
      const f = data => {
        for (let i = 0; i < data.length; i++) {
          if (data[i].id === id) {
            searchId = id;
            break;
          } else if (data[i].children && data[i].children.length) {
            f(data[i].children);
          }
        }
      };
      if (template.myTemplate) {
        f(template.myTemplate);
      }
      // 如果自定义中没有找到则在原始模板中查找
      if (!searchId) {
        if (this.knowledgeDic[id]) {
          searchId = id;
        }
      }
      return searchId ? searchId : '';
    },
    // 通过name查找影像诊断id
    queryTemplatesByName(name) {
      let id;
      // 在自定义模板中查找
      const f = (data) => {
        for (let i = 0; i < data.length; i++) {
          if (data[i].name === name) {
            id = data[i].id;
            break;
          } else if (data[i].children && data[i].children.length) {
            f(data[i].children);
          }
        }
      };
      if (template.myTemplate) {
        f(template.myTemplate);
      }
      // 如果自定义模板中为找到就在原始模板中找
      for (const item of this.allDisease) {
        if (item.value === name) {
          id = item.id;
          break;
        }
      }
      return id;
    },
    // 通过name查找自定义模板中影像诊断id
    queryMyTemplatesByName(name) {
      let id;
      // 在自定义模板中查找
      const f = (data) => {
        for (let i = 0; i < data.length; i++) {
          if (data[i].name === name) {
            id = data[i].id;
            break;
          } else if (data[i].children && data[i].children.length) {
            f(data[i].children);
          }
        }
      };
      if (template.myTemplate) {
        f(template.myTemplate);
      }
      return id;
    },
    // 获取医生自定义模板
    async queryMyTemplate() {
      // 请求医生自定义的模板路径
      const res = await this.$apollo.query({
        query: gql`{
          me{
            id
            template
          }
        }`,
        fetchPolicy: 'no-cache',
      });
      // 根据路径请求模板
      const path = res.data.me.template;
      // 如果没有自定义模板
      if (path === '') {
        template = {};
        return;
      }
      const msg =  await axios.request({
        method: 'get',
        url: api.template + path,
      });
      template = msg.data;
    },
    async getKnowledgeDic() {
      // 获取报告模板病名与id文件
      try {
        const knowledgeDic = await axios.request({
          method: "get",
          url: api.knowledgeDic
        });
        this.knowledgeDic = knowledgeDic.data;
        // 生成影像诊断筛选数据
        const allDiseaseArr = [];
        for (let key in this.knowledgeDic) {
          if (this.knowledgeDic.hasOwnProperty(key)) {
            allDiseaseArr.push({
              value: this.knowledgeDic[key].name,
              id: key
            });
          }
        }
        this.allDisease = allDiseaseArr;
      } catch (error) {
        this.$message.error(error.message.split(":")[1]);
      }
    },
    queryDisease(queryString, cb) {
      const restaurants = this.allDisease;
      const results = queryString ? restaurants.filter(this.filterDisease(queryString)) : restaurants;
      const arr = [];
      const f = (data) => {
        for (let i = 0; i < data.length; i++) {
          if (!data[i].children && data[i].id !== '1' && data[i].id !== '2' && data[i].id !== '3' && data[i].id !== '4' && data[i].id !== '5' && !data[i].subclass) {
            if (data[i].name.toLowerCase().indexOf(queryString.toLowerCase()) >= 0) {
              arr.push({
                id: data[i].id,
                value: data[i].name,
              })
            }
          } else if (data[i].children && data[i].children.length) {
            f(data[i].children);
          }
        }
      };
      if (template.myTemplate) {
        f(template.myTemplate);
      }
      for (const item of results) {
        const findIndex = arr.findIndex(item1 => item.value === item1.value);
        if (findIndex === -1) {
          arr.push(item);
        }
      }
      cb(arr);
    },
    filterDisease(queryString) {
      return restaurant => {
        return (
          restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) >= 0
        );
      };
    },
    selectedDisease(item) {
      console.log(item);
      // this.selectedDiagnose = true;
      // this.inHospitalData.diagnosis = item.value;
      // this.diagnosisId = item.id;
    },
  },
  // async mounted() {
  //   await this.getKnowledgeDic();
  //   await this.queryMyTemplate();
  // },
}
